// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--f5c1a";
export var category = "Accordion-module--category--11ecc";
export var closed = "Accordion-module--closed--5fe57";
export var fadeSlideDown = "Accordion-module--fade-slide-down--bc2bd";
export var fadeSlideUp = "Accordion-module--fade-slide-up--85253";
export var heading = "Accordion-module--heading--ca6b9";
export var open = "Accordion-module--open--234b5";
export var text = "Accordion-module--text--83728";
export var textContainer = "Accordion-module--textContainer--9c6b4";